import React,  { useState } from 'react';
import { find, sum } from 'lodash';
import ReactTable from 'react-table';
import Box from '../../common/Box';
import IncrementalLineChart from '../../widgets/charts/types/IncrementalLineChart';
import DoughnutChart from '../../widgets/charts/types/DoughnutChart';
import StackedBarChart from '../../widgets/charts/types/StackedBarChart';
import CSV from '../../../helpers/CSVExport';
import countriesByAbbreviation from '../../common/CountriesByAbbreviation';
import { splitByThousands } from '../../../helpers/NumberFormatter';
import { formatTooltipLabelDoughnutWithPercentage, formatTooltipLabelWithCurrency } from '../../widgets/charts/Formatter';
import { territoriesBar, territoriesLine, territoriesPie } from '../../widgets/charts/ChartDefaults';

var pieSvg = require('!svg-inline-loader!../../../../public/img/pie.svg');
var lineSvg = require('!svg-inline-loader!../../../../public/img/line.svg');
var tableSvg = require('!svg-inline-loader!../../../../public/img/table.svg');
var barSvg = require('!svg-inline-loader!../../../../public/img/chart-bar.svg');
var downloadSvg = require('!svg-inline-loader!../../../../public/img/download.svg');

const toolbarChartViewIcons = {
		table: tableSvg,
		line: lineSvg,
		pie: pieSvg,
		bar: barSvg
}

export default function Countries(props) {
	const [mode, setMode] = useState('line');
	
	const { countries = [], continent, loading, results = {}, table = [] } = props;
	const { period } = results;
	
	const getCountryName = (country) => {
		const countryData = find(countriesByAbbreviation, {abbreviation: country.toUpperCase()});
		let countryName = country;
		if(countryData)
			countryName = countryData.country;
		return countryName;	
	}
	
	const exportToCsv = () => {
		let data = [];
		for(let index in period) {
			let row = {
				period: period[index]
			}
			for(let country of Object.keys(countries)) {
				row[getCountryName(country)] = countries[country][index]
			}
			data.push(row)
		}
		const filename = CSV.CSVHeader('countries', ''); 
		return CSV.CSVExport(data, {filename}, 'countries');
	}
	
	const getOtherCountries = (countries) => {
		let otherCountries = {},
			otherSum = null;
		const countryCodes = Object.keys(countries);
		
		for(let countryCode in countryCodes) {
			const country = countryCodes[countryCode];
			if(countryCode < 10) {
				otherCountries[country] = countries[country];
			}
			else {
				const values = countries[country];
				if(!otherSum)
					otherSum = new Array(values.length).fill(0);
				values.forEach((value, index) => {
					otherSum[index] += value;
				});
			}
		};
		if(otherSum)
			otherCountries['Other'] = otherSum;
		return otherCountries;

		
	}

	
	const getTimeseries = () => {
		let datasets = [];
		const otherCountries = getOtherCountries(countries);
		
		for(let country of Object.keys(otherCountries)) {
			datasets.push({
				datasetKey: country,
				label: getCountryName(country),
				data: otherCountries[country]
			})
		}
		return {
			labels: period,
			datasets
		};		
	}
	
	const getPie = () => {
		let dataset = [], labels = [];
		const otherCountries = getOtherCountries(countries);
		for(let country of Object.keys(otherCountries)) {
			labels.push(getCountryName(country))
			dataset.push(sum(otherCountries[country]));
		}
		return {
			labels: labels,
			datasets: [{
				data: dataset, label: 'revenue'
			}]
		};		
	}
	
	const _getTable = () => {
		let tableData = [];
		for(let index in period) {
			let row = {
				period: period[index]
			};
			for(let country of Object.keys(countries)) {
				row[country] = countries[country][index];
			}
			tableData.push(row);
		}
		const commonColumnProps = {
			// className: 'table-text-right', 
			// headerClassName: 'table-text-right',
		};
		let columns = [{
			id: 'period',
			accessor: 'period',
			Header: 'Period',
			...commonColumnProps
		}];
		for(let country of Object.keys(countries)) {
			columns.push({
				id: `country_${country}`,
				accessor: country,
				Header: getCountryName(country),
				Cell: props => <span>{splitByThousands(props.value, '$')}</span>,
				...commonColumnProps	
			})
		}
		return <ReactTable 
			className=""
			data={tableData} 
			columns={columns}
			defaultPageSize={10}
			showPagination={true}        	
		/>
	}
	
	const getTable = () => {
		let tableData = [];
		
		for(let country of Object.keys(countries)) {
			let row = {
				country: getCountryName(country),
			};
			for(let index in period) {
				const periodName = period[index];
				row[periodName] = countries[country][index];
			}
			tableData.push(row);
		}
		const commonColumnProps = {
			// className: 'table-text-right', 
			// headerClassName: 'table-text-right',
		};
		let columns = [{
			id: 'country',
			accessor: 'country',
			Header: 'Country',
			...commonColumnProps
		}];
		for(let periodName of period) {
			columns.push({
				id: `period_${periodName}`,
				accessor: periodName,
				Header: periodName,
				Cell: props => <span>{splitByThousands(props.value, '$')}</span>,
				...commonColumnProps	
			})
		}
		return <ReactTable 
			className=""
			data={tableData} 
			columns={columns}
			defaultPageSize={10}
			showPagination={true}        	
		/>
	}
	
	const renderToolbar = () => {
		let toolbar = [];
		let views = {
			'table': 'table',
			'line': 'chart-line',
			'bar': 'chart-bar',
			'pie': 'chart-pie'
		}
		// for (let view in views) {
		// 	toolbar.push(<a key={view}><i className={`fa fa-${views[view]} ${mode == view ? 'active' : ''}`} onClick={()=>setMode(view)}></i></a>);
		// }
		// toolbar.push(<a key='download'><i className={`fa fa-cloud-download-alt`} onClick={()=>exportToCsv()}></i></a>);

		for (let view in views) {
			toolbar.push(<a key={view} className={`chart-icon ${mode == view? 'active' : ''}`} onClick={()=>setMode(view)} dangerouslySetInnerHTML={{__html: toolbarChartViewIcons[view]}}></a>);
		}
		toolbar.push(<a key='download' className="chart-icon" onClick={()=>exportToCsv()} dangerouslySetInnerHTML={{__html: downloadSvg}}></a>);
		return toolbar;
	}
	
	const widgetTitle = continent ?  'Territories' : 'Split by Macro Territory';
	
	return <Box title={widgetTitle} spinnerEnabled={loading} toolbar={renderToolbar()} className="home-box territories-box">
		{period && <div className="chart-block">
			{mode == 'line' && <IncrementalLineChart data={getTimeseries()} options={territoriesLine()} chartID="territories_report_countries_chart" />}
			{mode == 'bar' && <StackedBarChart data={getTimeseries()} isCustomWidth={true} options={territoriesBar()} chartID="territories_report_countries_chart" />}
			{mode == 'pie' && <DoughnutChart data={getPie()} options={territoriesPie}  chartID="territories_report_countries_chart" />}
			{mode == 'table' && getTable()}
		</div>}
	</Box>
}
